var Field = require('../field'),
	getComponentAttrs = Field.getComponentAttrs,
	renderAttrs = Field.renderAttrs;

// The init function is called on both the server and browser
// before rendering
exports.init = function(model) {
    var args = getComponentAttrs(model);
    args.class = 'btn' + (args.class ? ' ' + args.class: ' btn-default');
    model.set('buttonOpenTag', '<button' + renderAttrs(args) + '>');
    delete args.label;
}